import React from "react";
import { useHistory } from "react-router-dom";
import images from "../../../../utilities/images/images";
import "./EngageProfile.css";

function EngageProfile({
  avatarSrc = images.dummy_user_img,
  name = "Rohit Sharma",
  subtitle = "JEE • Class 11 • Anushaasan Live",
  tierLabel = "",
  showCheckmarkBadge = false,
  dailyGoalLabel = "Your Daily Goal",
  dailyGoalValue = "03/15",
  dailyGoalSuffix = "Solved",
  xpLabel = "XP Points (Total)",
  xpValue = "2.5k",
  xpSuffix = "points",
  onDailyGoalClick,
  onInfoClick,
}) {
  const history = useHistory();
  const tierTrimmed = String(tierLabel ?? "").trim();
  const isElite = tierTrimmed.toLowerCase() === "elite";

  return (
    <section className="engage-profile" aria-label="Engage profile">
      <div className="engage-profile__left">
        <div className="engage-profile__avatar-area">
          <img
            className="engage-profile__avatar"
            src={avatarSrc}
            alt=""
            aria-hidden="true"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = images.dummy_user_img;
            }}
          />
          <div className="engage-profile__avatar-edit-wrap">
            <button
              type="button"
              className="engage-profile__avatar-edit-btn"
              aria-label="Edit profile"
              onClick={() => history.push("/profile")}
            >
              <img
                src={images.engage_editgoal_icon}
                alt=""
                className="engage-profile__avatar-edit-img"
                width={18}
                height={18}
                aria-hidden="true"
              />
            </button>
          </div>
        </div>

        <div className="engage-profile__identity">
          <div className="engage-profile__name-row">
            <h3 className="engage-profile__name">{name}</h3>
            {showCheckmarkBadge ? (
              <img
                className="engage-profile__checkmark-badge"
                src={images.engage_checkmark_badge}
                alt=""
                width={22}
                height={22}
                aria-hidden="true"
              />
            ) : null}
          </div>
          {subtitle ? <p className="engage-profile__subtitle">{subtitle}</p> : null}

          {isElite ? (
            <span className="engage-profile__elite-badge" aria-label="Tier: Elite">
              <img
                className="engage-profile__elite-badge__coin"
                src={images.engage_elite_gold}
                alt=""
                width={22}
                height={22}
                aria-hidden="true"
              />
              <span className="engage-profile__elite-badge__text">ELITE</span>
            </span>
          ) : tierTrimmed ? (
            <span className="engage-profile__tier" aria-label={`Tier: ${tierTrimmed}`}>
              {tierTrimmed}
            </span>
          ) : null}
        </div>
      </div>

      <div className="engage-profile__right" aria-label="Stats">
        <div className="engage-profile__stat">
          <div className="engage-profile__stat-head">
            <span className="engage-profile__stat-label">{dailyGoalLabel}</span>
            <button
              type="button"
              className="engage-profile__info-btn"
              aria-label="Open daily goal settings"
              onClick={onDailyGoalClick}
            >
              <img src={images.engage_editgoal_icon} alt="" className="engage-profile__info-img" aria-hidden="true" />
            </button>
          </div>
          <div className="engage-profile__stat-value">
            <span className="engage-profile__stat-main">{dailyGoalValue}</span>
            <span className="engage-profile__stat-sub">{dailyGoalSuffix}</span>
          </div>
        </div>

        <div className="engage-profile__stat">
          <div className="engage-profile__stat-head">
            <span className="engage-profile__stat-label">{xpLabel}</span>
            <button type="button" className="engage-profile__info-btn" onClick={onInfoClick} aria-label="Open details">
              <img src={images.info} alt="" className="engage-profile__info-img" aria-hidden="true" />
            </button>
          </div>
          <div className="engage-profile__stat-value">
            <span className="engage-profile__stat-main">{xpValue}</span>
            <span className="engage-profile__stat-sub">{xpSuffix}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EngageProfile;
